const api = '/api'

export const ApiLogin = api+'/auth/login'
export const ApiAdmin = api+'/auth/admin'
export const ApiRegister = api+'/auth/register'
export const ApiJWTRefresh = api+'/auth/refresh'
export const ApiLogout = api+'/auth/logout'
export const ApiUser = api+'/auth/user'
export const ApiCatalog = api+'/mods'
export const ApiPopular = api+'/popular'
export const ApiNovelties = api+'/novelty'
export const ApiComments = api+'/comments'
export const ApiModComments = ApiCatalog+'/comments'
export const ApiCommentsCount = ApiModComments+'/count'
export const ApiViewMod = ApiCatalog+'/view'
export const ApiDownloadMod = ApiCatalog+'/download'
export const ApiFavorites = api+'/favorites'
export const ApiVersions = api+'/versions'
export const ApiTopViewsWeek = ApiCatalog+'/top_views_week'
export const ApiTopDownloadsWeek = ApiCatalog+'/top_downloads_week'
export const ApiModsSimilar = ApiCatalog+'/similar'
export const ApiConfirmComment = ApiComments+'/confirm'
export const ApiCatalogSearch = api+'/search'
export const ApiNotifications = api+'/notifications'
export const ApiNotificationsCount = ApiNotifications+'/count'
export const ApiExistUnreadNotifications = ApiNotifications+'/unread'
export const ApiStatistics = api+'/statistics'
export const ApiNews = api+'/news'
export const ApiModVideo = ApiCatalog+'/video'